import { Skeleton } from '@crehana/compass.ui';

export const InfoActivitySkeleton = () => {
  return (
    <div className=" tw-inline-block tw-bg-neutral-light-100 tw-rounded-[10px] tw-p-2 tw-pt-4.4 tw-w-full">
      <div className="tw-pr-3.6">
        <Skeleton
          animated
          className="tw-h-[2.1rem] tw-w-full tw-rounded-full tw-mb-0.8"
        />
        <Skeleton
          animated
          className="tw-h-[2.1rem] tw-w-full tw-rounded-full tw-mb-0.8"
        />
      </div>

      <div className="tw-border-b tw-border-solid tw-border-neutral-light-300 tw-pb-[8.9rem]">
        <Skeleton animated className="tw-h-[2.1rem] tw-w-1/2 tw-rounded-full" />
      </div>
      <div className="tw-pr-3.6">
        <div className="tw-w-1/2 tw-flex tw-mt-2 tw-mb-3.2">
          <Skeleton
            animated
            className="tw-h-2.4 tw-w-1/2 tw-rounded-full tw-mb-0.8 tw-mr-1.2"
          />
          <Skeleton
            animated
            className="tw-h-2.4 tw-w-1/2 tw-rounded-full tw-mb-0.8"
          />
        </div>
        <Skeleton
          animated
          className="tw-h-1.2 tw-w-1/3 tw-rounded-full tw-mb-0.8"
        />
        <Skeleton
          animated
          className="tw-h-1.6 tw-w-full tw-rounded-full tw-mb-2.4"
        />
        <Skeleton
          animated
          className="tw-h-1 tw-w-full tw-rounded-full tw-mb-0.8"
        />
        <Skeleton
          animated
          className="tw-h-1 tw-w-full tw-rounded-full tw-mb-0.8"
        />
        <Skeleton
          animated
          className="tw-h-1 tw-w-1/2 tw-rounded-full tw-mb-2.4"
        />
      </div>
    </div>
  );
};
